import React from 'react';

// import { dispatch, select, subscribe } from '@wordpress/data';

import TracksList from './TracksList';

/**
 * Tracks Area.
 *
 */
function TracksArea() {
  return (
    <div className="tracks-area">
      <TracksList />
    </div>
  );
}


export default TracksArea;
